var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntelXeon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 152,
    viewBox: "0 0 150 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1704_2033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 0.609375H0V151.086H150V0.609375Z",
    fill: "url(#paint0_linear_1704_2033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.999 116.531H115.555V151.085H149.999V116.531Z",
    fill: "url(#paint1_linear_1704_2033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.999 0.609375H115.555V116.532H149.999V0.609375Z",
    fill: "#1B5689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.556 116.531H0V151.085H115.556V116.531Z",
    fill: "#1B5689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.333 62.1927V89.5014H129.722L112.5 69.4379V89.5014H108.333V62.1927H111.944L129.166 82.2562V62.1927H133.333ZM89.1662 61.9141C97.2218 61.9141 103.611 68.0446 103.611 75.847C103.611 83.6495 97.4996 89.78 89.1662 89.78C81.1107 89.78 74.7218 83.6495 74.7218 75.847C74.9996 68.0446 81.1107 61.9141 89.1662 61.9141ZM89.1662 85.8788C94.7218 85.8788 99.1662 81.4202 99.1662 75.847C99.1662 70.2739 94.7218 65.8153 89.1662 65.8153C83.6107 65.8153 79.1662 70.2739 79.1662 75.847C79.1662 81.4202 83.6107 85.8788 89.1662 85.8788ZM71.3885 77.7977C71.3885 77.2404 71.3885 76.4044 71.3885 75.847C71.3885 68.0446 65.2773 61.9141 56.944 61.9141C48.6107 61.9141 42.4996 68.0446 42.4996 75.847C42.4996 83.6495 48.6107 89.78 56.944 89.78C63.0551 89.78 66.6662 87.5508 69.1662 84.4855L65.8329 81.9776C63.6107 84.7642 60.5551 86.1575 56.944 86.1575C51.944 86.1575 48.0551 82.5349 46.944 77.7977H71.3885V77.7977ZM57.2218 65.8153C62.2218 65.8153 66.3885 69.4379 67.2218 74.1751H47.2218C48.0551 69.1592 52.2218 65.8153 57.2218 65.8153ZM42.2218 62.1927H36.944L28.6107 72.5031L20.2773 62.1927H15.2773L26.1107 75.847L15.2773 89.5014H20.5551L28.8885 79.191L37.2218 89.5014H42.4996L31.3885 75.847L42.2218 62.1927Z",
    fill: "url(#paint2_linear_1704_2033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.056 62.1927C138.889 62.1927 139.722 63.0287 139.722 63.8647C139.722 64.7007 138.889 65.5366 138.056 65.5366C137.222 65.5366 136.389 64.7007 136.389 63.8647C136.389 63.0287 137.222 62.1927 138.056 62.1927ZM138.056 61.9141C136.945 61.9141 136.111 62.75 136.111 63.8647C136.111 64.9793 136.945 65.8153 138.056 65.8153C139.167 65.8153 140 64.9793 140 63.8647C139.722 62.75 138.889 61.9141 138.056 61.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.056 62.75H138.333C138.333 62.75 138.611 62.75 138.611 63.0287V63.3073V63.586L138.333 63.8646L138.889 64.7006H138.611L138.333 64.1433H137.778V64.7006H137.5V62.75H138.056ZM138.056 63.8646C138.056 63.8646 138.333 63.8646 138.056 63.8646C138.333 63.586 138.333 63.586 138.056 63.8646C138.333 63.586 138.333 63.586 138.333 63.586C138.333 63.586 138.333 63.586 138.333 63.3073C138.333 63.3073 138.333 63.3073 138.056 63.3073H137.5V63.8646H138.056V63.8646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2771 13.9844H16.666V17.6069H20.2771V13.9844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2771 20.1162H16.666V33.4919H20.2771V20.1162ZM43.3327 33.4919V30.148C42.7771 30.148 42.4993 30.148 41.9438 30.148C41.666 30.148 41.3882 29.8693 41.1105 29.8693C40.8327 29.5906 40.8327 29.312 40.8327 29.0333C40.8327 28.7547 40.8327 28.1973 40.8327 27.64V22.9028H43.3327V20.1162H40.8327V14.8217H37.2216V27.64C37.2216 28.7547 37.2216 29.5906 37.4993 30.4266C37.7771 31.2626 38.0549 31.8199 38.3327 32.0986C38.8882 32.6559 39.4438 32.9346 39.9993 32.9346C40.8327 33.2132 41.666 33.2132 42.7771 33.2132H43.3327V33.4919ZM63.3327 13.707H59.7216V33.2132H63.3327V13.707ZM33.8882 21.2308C33.0549 20.1162 31.666 19.5589 29.7216 19.5589C28.8882 19.5589 28.0549 19.8375 27.4993 20.1162C26.9438 20.6735 26.3882 21.2308 25.8327 21.7882V22.0668V21.7882V20.1162H22.2216V33.4919H25.5549V26.2467V26.804V26.5254C25.5549 25.4107 25.8327 24.2961 26.3882 23.7388C27.2216 23.1815 28.0549 22.9028 28.8882 22.9028C29.9993 22.9028 30.5549 23.1815 31.1105 23.7388C31.666 24.2961 31.9438 25.1321 31.9438 26.2467V33.2132H35.5549V25.6894C35.5549 24.0174 34.9993 22.3455 33.8882 21.2308ZM58.0549 26.5254C58.0549 25.6894 57.7771 24.5748 57.4993 23.7388C57.2216 22.9028 56.666 22.0668 56.1105 21.5095C55.5549 20.9522 54.7216 20.3949 53.8882 20.1162C53.0549 19.8375 52.2216 19.5589 51.1105 19.5589C50.2771 19.5589 49.166 19.8375 48.3327 20.1162C47.4993 20.3949 46.666 20.9522 46.1105 21.5095C45.5549 22.0668 44.9993 22.9028 44.7216 23.7388C44.4438 24.8534 44.4438 25.6894 44.4438 26.804C44.4438 27.9187 44.7216 28.7547 44.9993 29.5906C45.2771 30.4266 45.8327 31.2626 46.3882 31.8199C46.9438 32.3772 47.7771 32.9346 48.6105 33.2132C49.4438 33.4919 50.5549 33.7705 51.3882 33.7705C54.4438 33.7705 56.1105 32.3772 57.2216 31.2626L54.7216 29.312C54.166 29.8693 53.0549 30.7053 51.3882 30.7053C50.2771 30.7053 49.7216 30.4266 48.8882 30.148C48.3327 29.5906 47.7771 29.0333 47.4993 28.1973H57.7771V26.5254H58.0549ZM47.7771 25.4107C47.7771 24.5748 48.8882 22.6241 51.3882 22.6241C53.8882 22.6241 54.9993 24.2961 54.9993 25.4107H47.7771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4991 29.8685C68.3325 29.8685 69.1658 30.7045 69.1658 31.5405C69.1658 32.3764 68.3325 33.2124 67.4991 33.2124C66.6658 33.2124 65.8325 32.3764 65.8325 31.5405C65.8325 30.7045 66.6658 29.8685 67.4991 29.8685ZM67.4991 29.5898C66.388 29.5898 65.5547 30.4258 65.5547 31.5405C65.5547 32.6551 66.388 33.4911 67.4991 33.4911C68.6102 33.4911 69.4436 32.6551 69.4436 31.5405C69.4436 30.4258 68.6102 29.5898 67.4991 29.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4989 30.7031H67.7767C67.7767 30.7031 68.0545 30.7031 68.0545 30.9818V31.2604V31.5391L67.7767 31.8178L68.3323 32.6537H68.0545L67.7767 32.0964H67.2211V32.6537H66.9434V30.7031H67.4989ZM67.4989 31.5391C67.7767 31.5391 67.7767 31.5391 67.4989 31.5391C67.7767 31.5391 67.7767 31.5391 67.4989 31.5391C67.7767 31.2604 67.7767 31.2604 67.7767 31.2604C67.7767 31.2604 67.7767 31.2604 67.7767 30.9818C67.7767 30.9818 67.7767 30.9818 67.4989 30.9818H66.9434V31.5391H67.4989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5549 129.352C22.4993 129.352 23.6105 130.745 23.6105 132.417C23.6105 134.089 22.2216 135.482 20.5549 135.482H18.6105V138.547H16.666V129.63H20.5549V129.352ZM18.6105 131.024V133.531H20.2771C21.1105 133.531 21.666 132.974 21.666 132.138C21.666 131.302 21.1105 130.745 20.2771 130.745H18.6105V131.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9434 138.269V129.352H28.8878V136.597H33.0545V138.269H26.9434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7778 136.039L36.9444 138.269H35L38.6111 129.352H40.5556L44.1667 138.269H42.2222L41.3889 136.039H37.7778ZM39.4444 131.581L38.3333 134.367H40.5556L39.4444 131.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2218 129.352V131.024H49.7218V138.269H47.7773V131.024H45.2773V129.352H52.2218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 129.352H56.9444V138.269H55V129.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6103 129.352V138.269H66.9436L62.4991 132.695V138.269H60.5547V129.352H62.2214L66.6658 134.925V129.352H68.6103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3333 134.646V129.352H80.2778V134.646C80.2778 136.875 78.6111 138.547 76.3889 138.547C74.1667 138.547 72.5 136.875 72.5 134.646V129.352H74.4444V134.646C74.4444 135.761 75.2778 136.875 76.3889 136.875C77.5 136.597 78.3333 135.761 78.3333 134.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9438 129.352H93.6105V138.269H91.666V132.417L88.8882 136.039L86.1105 132.417V138.269H84.166V129.352H85.8327L88.8882 133.253L91.9438 129.352Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1704_2033",
    x1: 0,
    y1: 0.609375,
    x2: 150.476,
    y2: 150.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00156647,
    stopColor: "#061C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625872,
    stopColor: "#071E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#0B2448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2107,
    stopColor: "#102D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2904,
    stopColor: "#143969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#144279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6702,
    stopColor: "#112F59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1704_2033",
    x1: 94.1539,
    y1: 98.4526,
    x2: 176.581,
    y2: 173.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1704_2033",
    x1: 74.2137,
    y1: 89.836,
    x2: 74.2137,
    y2: 61.8581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#BCC7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1704_2033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150.476,
    fill: "white",
    transform: "translate(0 0.609375)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelXeon);
export default __webpack_public_path__ + "static/media/intelXeon.ea567aecdf8efc5933da3ababf651d50.svg";
export { ForwardRef as ReactComponent };